var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Transition } from 'react-transition-group';
import React from 'react';
import { addClass, removeClass } from '../../Utils/browser';
var CollapseTransition = /** @class */ (function (_super) {
    __extends(CollapseTransition, _super);
    function CollapseTransition(props) {
        var _this = _super.call(this, props) || this;
        _this.onEnter = function (children) {
            addClass(children, 'collapse-transition');
            if (!children.dataset)
                children.dataset = {};
            children.dataset.oldPaddingTop = children.style.paddingTop;
            children.dataset.oldPaddingBottom = children.style.paddingBottom;
            children.style.height = '0';
            children.style.paddingTop = 0;
            children.style.paddingBottom = 0;
        };
        _this.onEntering = function (children) {
            children.dataset.oldOverflow = children.style.overflow;
            if (children.scrollHeight !== 0) {
                children.style.height = children.scrollHeight + 'px';
                children.style.paddingTop = children.dataset.oldPaddingTop;
                children.style.paddingBottom = children.dataset.oldPaddingBottom;
            }
            else {
                children.style.height = '';
                children.style.paddingTop = children.dataset.oldPaddingTop;
                children.style.paddingBottom = children.dataset.oldPaddingBottom;
            }
            children.style.overflow = 'hidden';
        };
        _this.onEntered = function (children) {
            removeClass(children, 'collapse-transition');
            children.style.height = '';
            children.style.overflow = children.dataset.oldOverflow;
        };
        _this.onExit = function (children) {
            if (!children.dataset)
                children.dataset = {};
            children.dataset.oldPaddingTop = children.style.paddingTop;
            children.dataset.oldPaddingBottom = children.style.paddingBottom;
            children.dataset.oldOverflow = children.style.overflow;
            children.style.height = children.scrollHeight + 'px';
            children.style.overflow = 'hidden';
        };
        _this.onExiting = function (children) {
            if (children.scrollHeight !== 0) {
                // for safari: add class after set height, or it will jump to zero height suddenly, weired
                addClass(children, 'collapse-transition');
                children.style.height = 0;
                children.style.paddingTop = 0;
                children.style.paddingBottom = 0;
            }
        };
        _this.onExited = function (children) {
            removeClass(children, 'collapse-transition');
            children.style.height = '';
            children.style.overflow = children.dataset.oldOverflow;
            children.style.paddingTop = children.dataset.oldPaddingTop;
            children.style.paddingBottom = children.dataset.oldPaddingBottom;
        };
        return _this;
    }
    CollapseTransition.prototype.render = function () {
        var _a = this.props, isIn = _a.in, timeout = _a.timeout, unmountOnExit = _a.unmountOnExit, children = _a.children;
        return (
        // @ts-ignore
        React.createElement(Transition, { in: isIn, timeout: timeout, unmountOnExit: unmountOnExit, onEnter: this.onEnter, onEntering: this.onEntering, onEntered: this.onEntered, onExit: this.onExit, onExiting: this.onExiting, onExited: this.onExited }, children));
    };
    CollapseTransition.defaultProps = {
        in: true,
        timeout: 300,
        unmountOnExit: true,
    };
    return CollapseTransition;
}(React.Component));
export { CollapseTransition };
